/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/core";
import { Box } from "@material-ui/core";
import { useI18n } from "hooks/i18n/i18n";
import { CheckIcon } from "ui/CheckIcon";

type Props = {
  showPurchasedToast: boolean;
};

export const StreamingLiveCommercePurchasedToast: React.FC<Props> = ({
  showPurchasedToast,
}) => {
  const styles = purchasedToastDesign({ showPurchasedToast });
  const { t } = useI18n();
  return (
    <Box css={styles.container}>
      <CheckIcon css={styles.icon} />
      <Box css={styles.textGroup}>
        <h2 css={styles.heading}>
          {t("streaming.commercePurchaseComplete.purchaseComplete")}
        </h2>
        <p css={styles.text}>
          {t("streaming.commercePurchaseComplete.purchaseCompleteCaution")}
        </p>
        <a
          href="/account/settlement/history"
          target="_blank"
          rel="noopener noreferrer"
          css={styles.link}
        >
          {t("streaming.commercePurchaseComplete.viewPurchaseHistory")}
        </a>
      </Box>
    </Box>
  );
};

type PurchasedToastDesignProps = {
  showPurchasedToast: boolean;
};

const purchasedToastDesign = ({
  showPurchasedToast,
}: PurchasedToastDesignProps) => {
  const container = css`
    position: absolute;
    bottom: 20px;
    left: 50%;
    gap: 12px;
    transform: translate(-50%, ${showPurchasedToast ? "-50%" : "-40%"});
    z-index: 20;
    padding: 16px;
    background-color: #f0f0f0;
    display: flex;
    border-radius: 4px;
    min-width: 280px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    opacity: ${showPurchasedToast ? 1 : 0};
    visibility: ${showPurchasedToast ? "visible" : "hidden"};
    transition: all 0.3s ease-in-out;
  `;

  const textGroup = css`
    display: flex;
    flex-direction: column;
  `;

  const icon = css`
    size: 20px;
    color: #000000;
  `;

  const heading = css`
    font-size: 18px;
    font-weight: 700;
    color: #000000;
    margin: 0;
    line-height: 24px;
  `;

  const text = css`
    font-size: 14px;
    color: #333333;
    margin-top: 6px;
    line-height: 20px;
    width: 226px;
  `;

  const link = css`
    display: inline-block;
    font-size: 14px;
    font-weight: 700;
    color: #000000;
    text-decoration: underline;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    line-height: 20px;
  `;

  return {
    container,
    icon,
    textGroup,
    heading,
    text,
    link,
  };
};
